import _ from 'lodash'

export default {
  inject: ['$validator'],
  computed: {
    isDirty () {
      return this.model !== null;
    },
    newName () {
      if (!this.name) return '__safe__'; // must NEVER be empty/undefined

      if (this.validScope) {
        return this.validScope + '.' + this.name;
      }

      return this.name;
    }
  },
  mounted() {
    if (!this.name) {
      // console.error('Missing name in component:', this.$options.name || this);
    }
  },
  data () {
    return {
      model: this.resolveValue(),
    }
  },
  methods: {
    resolveValue () {
      if (this.values && this.lang && this.lang.code) {
        const val = this.values[this.lang.code];

        if (val !== undefined) {
          return this.resolver ? this.resolver(val) : val;
        }
      }

      return this.value !== undefined && this.value !== null ? this.value : '';
    }
  },
  props: {
    name: {
      default: '',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    value: {
      default: '',
      type: [Number, String, Object, Boolean]
    },
    values: {
      default: () => undefined,
      type: Object,
    },
    lang: {
      default: () => { return {} },
      type: Object,
    },
    rules: {
      default: () => { return {} },
    },
    disabled: {
      default: false,
      type: Boolean
    },
    resolver: {
      default: null,
      type: Function
    },
    type: {
      default: null,
      type: String
    },
    maxlength: {
      default: null,
      type: String
    },
    scope: {
      default: null,
      type: String
    },
    validScope: {
      default: null,
      type: String
    }
  },
  watch: {
    value (value) {
      this.model = value
    },
    model (value) {
      this.$emit('input', value);
    }
  }
}
